<script>
import DashHeader from "../components/layout/DashHeader"
import GlobalSidebar from "@/components/GlobalSidebar"
import { mapActions, mapGetters, mapMutations } from "vuex"

export default {
    name: "GlobalDashLayout",
    components: {
        GlobalSidebar,
        DashHeader,
    },
    data: function () {
        return {
            search: "",
            menu2: null,
            menu: null,
            isOnMobile: false,
            classes: {},
            companies: [],
        }
    },
    computed: {
        ...mapGetters("sidebar", {
            sidebarMenu: "sidebarMenu",
            isSidebarVisible: "isSidebarVisible",
            isSidebarLoading: "isSidebarLoading",
            selectedCompany: "company",
        }),
        isImpersonating() {
            return this.$store.getters["auth/impersonating"]
        },
        companyId() {
            return this.$route.params.companyId
        },
        locationId() {
            return this.$route.params.locationId
        },
        isSidebarCollapsed: {
            get: function () {
                return !this.isSidebarVisible
            },
            set: function (value) {
                return this.setSidebarVisibility(!value)
            },
        },
    },
    mounted() {
        this.setContentRef(this.$refs.contentDiv)
        this.setLocation(null)
        this.getCompanies()
    },
    watch: {
        $route: function (to) {
            let companyId = to.params?.companyId

            if (this.selectedCompany?.id !== companyId) {
                let company = this.companies.find((company) => company.id == companyId)

                if (company) {
                    this.setCompany(company)
                }
            }
        },
    },
    methods: {
        ...mapActions("sidebar", {
            setCompany: "setCompany",
            setLocation: "setLocation",
            fetchMenu: "fetchMenu",
        }),
        ...mapMutations("appLayoutModule", ["setContentRef"]),
        getCompanies() {
            this.isLoading = true

            this.axios
                .get("/companies")
                .then((response) => {
                    this.companies = response.data.data.companies

                    this.$store.dispatch(
                        "breadcrumbs/transformCompaniesData",
                        response.data.data.companies,
                    )

                    if (this.$route.path === "/settings/global" && this.selectedCompany !== null) {
                        this.$router.push(
                            `/settings/global/companies/${this.selectedCompany.id}/locations`,
                        )
                    } else if (this.selectedCompany === null) {
                        let companyId = this.$route.params.companyId
                        let company = this.companies.find((company) => company.id == companyId)

                        if (company) {
                            this.setCompany(company)
                        }
                    }
                })
                .catch((error) => {})
                .finally(() => {
                    this.isLoading = false
                })
        },
    },
}
</script>

<template>
    <div id="wrapper">
        <GlobalSidebar :companies="companies" />

        <div ref="contentDiv" id="content" class="main-content" style="overflow: hidden">
            <dash-header></dash-header>

            <div class="inner-content" style="overflow-x: hidden; overflow-y: auto">
                <router-view></router-view>
            </div>
        </div>
    </div>
</template>

<style scoped>
.main-content {
    padding-bottom: 60px !important;
}

@media (max-width: 768px) {
    .main-content {
        padding-bottom: 40px !important;
    }
}
</style>
